import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { LayoutGrid, Radio, MessageCircle, User, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const TABS = [
  { to: "/directory", label: "Haus", icon: LayoutGrid, testid: "tab-directory", match: (p) => p.startsWith("/directory") },
  { to: "/radio", label: "Radio", icon: Radio, testid: "tab-radio", match: (p) => p.startsWith("/radio") },
  { to: "/briefs", label: "Briefs", icon: FileText, testid: "tab-briefs", match: (p) => p.startsWith("/briefs") },
  { to: "/messages", label: "Messages", icon: MessageCircle, testid: "tab-messages", match: (p) => p.startsWith("/messages") },
  { to: "/profile", label: "Profile", icon: User, testid: "tab-profile", match: (p) => p === "/profile" },
];

export function MobileTabBar() {
  const { user } = useAuth();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) return;
    if (typeof window !== "undefined" && !window.matchMedia("(max-width: 767px)").matches) return;
    let alive = true;
    const poll = () => api.get("/conversations").then((r) => { if (alive) setUnread(r.data.unread_total || 0); }).catch(() => {});
    poll();
    const t = setInterval(poll, 15000);
    return () => { alive = false; clearInterval(t); };
  }, [user, location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("has-mobile-tabbar", !!user);
    return () => document.body.classList.remove("has-mobile-tabbar");
  }, [user]);

  if (!user) return null;

  return (
    <nav
      data-testid="mobile-tab-bar"
      className="md:hidden fixed bottom-0 left-0 w-full z-50 bg-ink border-t border-line grid grid-cols-5"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map(({ to, label, icon: Icon, testid, match }) => {
        const active = match(location.pathname);
        return (
          <Link
            key={to}
            to={to}
            data-testid={testid}
            className={`relative flex flex-col items-center justify-center gap-1 py-2.5 min-h-[60px] transition-colors ${
              active ? "text-gold" : "text-ash active:text-cream"
            }`}
          >
            <span className="relative">
              <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
              {testid === "tab-messages" && unread > 0 && (
                <span data-testid="tab-messages-unread" className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 bg-red-600 text-white text-[9px] font-bold flex items-center justify-center rounded-full">
                  {unread > 9 ? "9+" : unread}
                </span>
              )}
            </span>
            <span className="font-mono text-[9px] uppercase tracking-[0.12em]">{label}</span>
            {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-gold" />}
          </Link>
        );
      })}
    </nav>
  );
}
